<!--
  @Author: The Jin
  @Date: 2025-05-26 15:56
  @FilePath: src\views\sop\addEditPopup.vue
  @Description: 新建任务  编辑任务
  @LastEditors:  The Jin
  @LastEditTime: 2025-05-26
  @LastDescription: 
 -->

<template>
    <el-dialog title="选择群聊" @close="closeDialog" :visible.sync="dialogVisibleM" :modal-append-to-body="false" width="70%"
        class="add-label-dialog" :close-on-click-modal="false">
        <div class="dialog-container" v-loading="loading">
            <div class="cus-chat-supervise-search">
                <el-form :inline="true">
                    <el-form-item label="群名称" class="el-form-item">
                        <el-input style="width: 120px;"  v-model="formInline.chatName" size="mini" clearable @change="selectBindStatus" />
                    </el-form-item>
                    <el-form-item label="群主" class="el-form-item">
                        <el-input style="width: 120px;"  v-model="formInline.ownerName" size="mini" clearable @change="selectBindStatus" />
                    </el-form-item>
                    <el-form-item label="群标签" class="el-form-item">
                        <el-cascader style="width: 150px;"  v-model="searchTagItem" :options="tagList" :props="tagProps" size="mini"
                            @change="selectTagItem" :show-all-levels="false" />
                    </el-form-item>
                    <el-form-item label="建群时间" class="el-form-item">
                        <el-date-picker style="width: 240px;"  v-model="date" type="daterange" range-separator="至" start-placeholder="开始时间"
                            end-placeholder="结束时间" size="small" @change="selectBindStatus" />
                    </el-form-item>
                </el-form>
            </div>
            <div class="table-row" ref="tableWrapper">
                <el-table size="small" :data="tableData" fit highlight-current-row align="center"
                    :header-cell-style="{ background: '#eef1f6' }" ref="cusChatTable"
                    @selection-change="handleSelectionChange" :height="tableHeight">
                    <el-table-column type="selection" width="55" :selectable="checkSelection"> </el-table-column>
                    <el-table-column label="序号" width="80">
                        <template slot-scope="scope">
                            {{ getGlobalIndex(scope.$index) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="chatName" label="群名称" show-overflow-tooltip align="center">
                    </el-table-column>
                    <el-table-column prop="ownerName" label="群主" align="center">
                    </el-table-column>
                    <el-table-column prop="groupChatTagDetailDtoList" label="群标签" min-width="120" show-overflow-tooltip
                        align="center">
                        <template slot-scope="scope">
                            <el-tag v-for="item in scope.row.groupChatTagDetailDtoList" :key="item.tagId" size="small"
                                style="margin: 3px">
                                <el-popover placement="bottom-start" width="150" trigger="hover">
                                    <span slot="reference">{{ item.tagName }}</span>
                                    <el-tag v-for="item in scope.row.groupChatTagDetailDtoList" :key="item.tagId"
                                        size="small" style="margin: 3px" closable
                                        @close="deleteGroupTag(scope.row.chatId, item.tagId)">{{
                                            item.tagName
                                        }}</el-tag>
                                </el-popover>
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="memNum" label="群人数" align="center">
                    </el-table-column>
                    <el-table-column prop="memQuitNum" label="退群人数" align="center">
                    </el-table-column>
                    <el-table-column prop="dayMemQuitNum" label="当天进群/退群人数" align="center">
                        <template slot-scope="scope">
                            <span>{{
                                scope.row.dayMemJoinNum > 0 ? "+" + scope.row.dayMemJoinNum : 0
                            }}/{{ scope.row.dayMemQuitNum > 0 ? "-" + scope.row.dayMemQuitNum : 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="建群时间" align="center">
                    </el-table-column>
                </el-table>
            </div>
            <Pagination class="Pagination-row" v-bind:childMsg="pageparm" :pageSizes="pageSizes" @callBack="callBack">
            </Pagination>

        </div>
        <div slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between;align-items: center;">
            <span>已选：{{ selectedList.length || 0 }}条</span>
            <div>
                <el-button size="small " @click="closeDialog" style="margin-right:20px">取 消</el-button>
                <el-button type="primary" size="small" @click="confirmWeicome()" :disabled="loading">确 定</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import dayjs from "dayjs";
import {
    getList,
    getTagList,
} from "@/api/group/index.js";
export default {
    // 新建sop任务弹框
    name: "addEditPopup",
    components: {
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        disabledSelect: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            tableData: [],
            pageparm: {
                pageNum: 1,
                pageSize: 20,
                total: 10,
            },
            formInline: {
                pageNum: 1,
                pageSize: 20,
                chatName: "",
                ownerName: "",
                tagId: [],
                startTime: "",
                endTime: "",
            },
            pageSizes: [20, 50, 100, 200, 500], //分页条数
            date: null,
            searchTagItem: [],
            tagList: [],
            tagProps: {
                multiple: true, //是否允许多选
                label: "tagName",
                value: "tagId",
                children: "groupChatTagDetailDtoList",
                showAllLevels: false,
                // checkStrictly: true
                // checkStrictly: true
                // emitPath: false
            },
            /**选中的数据 */
            selectedList: [],
            cusChatTable: null,
            tableHeight: 200,
            tableWrapper: null,
            loading: false,
        }
    },

    watch: {
        dialogVisible: {
            handler(newVal, oldVal) {
                console.log("监听 dialogVisible", newVal);
                this.dialogVisibleM = newVal
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.$nextTick(() => {
            // 动态计算父容器高度
            this.tableHeight = this.$refs.tableWrapper.clientHeight;
        });
        // 窗口变化时更新（可选）
        window.addEventListener('resize', this.calculateHeight);
    },

    async created() {
        this.getList(this.formInline);
        this.getTag();
    },
    methods: {
        getGlobalIndex(index) {
            return (this.formInline.pageNum - 1) * this.formInline.pageSize + index + 1;
        },
        checkSelection(row, index) {
            if (this.disabledSelect.some(k => { return k.chatId == row.chatId })) {
                return false
            } else {
                return true
            }
        },

        getTag() {
            getTagList(localStorage.getItem("Authorization"), true).then((res) => {
                console.log(res);
                this.tagList = res.data.map((item) => {
                    return { ...item, tagName: item.groupName };
                });
            });
        },


        callBack(parm) {
            this.formInline.pageNum = parm.currentPage;
            this.formInline.pageSize = parm.pageSize;
            this.getList(this.formInline);
        },
        /**选中标签 */
        selectTagItem(list) {
            let tagList = [];
            if (list.length > 0) {
                list.forEach((item) => {
                    tagList.push(item[1]);
                });
            }
            this.formInline.tagId = [...tagList];
            this.getList(this.formInline);
        },
        selectBindStatus() {
            this.formInline.pageNum = 1;
            if (this.date != null) {
                this.formInline.startTime = dayjs(this.date[0]).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
                this.formInline.endTime =
                    dayjs(this.date[1]).format("YYYY-MM-DD") + " " + "23:59:59";
            } else {
                this.formInline.startTime = "";
                this.formInline.endTime = "";
            }
            this.getList(this.formInline);
        },
        /**获取表格数据 */
        getList(parameter) {
            this.loading = true
            getList(parameter, localStorage.getItem("Authorization"), true).then((res) => {
                this.loading = false
                if (res.error.code == 200) {
                    if (res.data.rows.length > 0) {
                        this.tableData = res.data.rows;
                        this.pageparm.total = res.data.count;
                    } else {
                        this.tableData = [];
                    }
                }
            }).catch(() => {
                this.loading = false
            })
        },

        /**关闭 */
        closeDialog(reset) {
            this.$emit('update:dialogVisible', false)
        },

        /**选中 */
        handleSelectionChange(val) {
            console.log('选中', val);

            this.selectedList = val
        },
        /**确定 */
        confirmWeicome() {
            console.log('确定');
            if (this.selectedList && this.selectedList.length) {
                this.closeDialog()
                this.$emit('selectedData', this.selectedList)
            } else {
                this.$message.warning("请选择数据再操作保存")
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.dialog-container {
    display: flex;
    flex-direction: column;
    // height: 60vh;

    .cus-chat-supervise-search {
        // height: 40px;
        line-height: 40px;
        // max-height: 80px;
        display: flex;
        justify-content: space-between;

        .el-form-item {
            margin-bottom: 6px !important;
        }
    }

    .table-row {
        height: calc(60vh - 150px);
        // flex: 1;
        // min-height: 200px;
    }

    .Pagination-row {
        height: 40px;
        text-align: right;
    }

}

.tips-row {
    height: 10px;
    line-height: 10px;
    color: #409eff;
    margin-top: 0 !important;
    margin-bottom: 20px;
    font-size: 12px；
}

.task-detail {
    padding: 0 11px;
    font-size: 12px;

    .detial-item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        .label {
            margin-right: 15px;
            font-size: 14px;
            font-weight: bold;
        }

        .icon-style {
            margin-left: 12px;
        }
    }

    /deep/.number-input {
        margin: 0 4px;

        .el-input__inner {
            padding: 0 4px 0 15px;
        }
    }
}
</style>
  